import React from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types'; 
import {Button, Image} from 'react-bootstrap';

class ProductBox extends React.Component {  
  render() {    
    return (
      <div className={this.props.boxClass} onClick={() => this.props.onClick(this)}>
        <div>
          <Image src={this.props.image} className={this.props.imageClass} alt={this.props.imageAlt} />
          {this.props.title?
            <h6>{this.props.title}</h6>
            :""
          }
          {this.props.counting?
            <p>{this.props.counting}</p>
              :""
          }
        </div>
      </div>
		);
	}
}


ProductBox.propTypes = {
  image: PropTypes.string.isRequired,
  imageClass: PropTypes.string,
  imageAlt: PropTypes.string,
  boxClass: PropTypes.string,
  title: PropTypes.string,
  counting: PropTypes.string,
  onClick: PropTypes.func.isRequired
};
ProductBox.defaultProps = {
  	imageAlt:'',
    image:'',
    imageClass:'',
    linkUrl: '',
    boxClass:'products-box',
    title:'',
    counting:'',
    onClick: () => {}
}

export default ProductBox;